import { Select } from '@mantine/core'
import { translate } from 'i18n/i18n'
import { mantineSelectSearchFilterProp } from 'utils/mantineSelectSearchFilterProp'
import { useSelectClickToggle } from 'utils/useSelectClickToggle'
import { getStyles } from './getStyles'

export const OrganizationSelect = ({
  clearable = true,
  data,
  disabled = false,
  onChange,
  selectedOrganizationId,
}: {
  clearable?: boolean
  data: { value: string; label: string }[]
  disabled?: boolean
  onChange?: (organizationId: number | null) => void
  selectedOrganizationId: number | null
}) => {
  const selectClickToggle = useSelectClickToggle()

  return (
    <Select
      {...selectClickToggle}
      autoComplete="off"
      allowDeselect={false}
      css={{ borderRadius: 3 }}
      clearable={clearable}
      data={data}
      disabled={disabled}
      filter={mantineSelectSearchFilterProp}
      onChange={
        onChange
          ? (organizationId) => {
              onChange(organizationId === null ? null : Number(organizationId))
            }
          : undefined
      }
      searchable
      size="sm"
      spellCheck="false"
      placeholder={translate.phrases.banyanApp('Select an Organization')}
      styles={getStyles(clearable, disabled)}
      value={selectedOrganizationId === null ? null : String(selectedOrganizationId)}
    />
  )
}
